import {
	GamedayApiService,
	MatchService
} from "@prestosports/prestostats-core/Services";
import {
	DELETE_MATCH_COMPLETE,
	EDIT_MATCH_COMPLETE,
	GET_MATCHES,
	GET_MATCHES_COMPLETE,
	SAVE_MATCH_COMPLETE
} from "./constants";
import GamedayApiClient from "../../services/gameday-api-client";
import Alert from "../../util/alert";
import { updateGameContext } from "../game-context/actions";
import { withQueuedSync, withSubmitting } from "../app/actions";

GamedayApiService.setGamedayApiClient(GamedayApiClient);

export const saveMatch = async (match, currentEventId, dispatch) =>
	withSubmitting(async () => {
		return withQueuedSync(
			currentEventId,
			async () => {
				const { matches, totals, gameContext } = await MatchService.saveMatch(
					match
				);
				dispatch({
					type: SAVE_MATCH_COMPLETE,
					payload: { matches, totals }
				});
				updateGameContext(gameContext, dispatch);
			},
			dispatch
		);
	}, dispatch);

export const editMatch = async (match, currentEventId, dispatch) =>
	withSubmitting(async () => {
		return withQueuedSync(
			currentEventId,
			async () => {
				const { matches, totals, gameContext } = await MatchService.saveMatch(
					match
				);
				dispatch({
					type: EDIT_MATCH_COMPLETE,
					payload: { matches, totals }
				});
				updateGameContext(gameContext, dispatch);
			},
			dispatch
		);
	}, dispatch);

export const getMatches = async (eventId, dispatch) => {
	dispatch({ type: GET_MATCHES });

	const { matches, totals } = await MatchService.getMatches(eventId);

	dispatch({
		type: GET_MATCHES_COMPLETE,
		payload: { matches, totals }
	});
};

export const deleteMatch = async (match, dispatch) =>
	withSubmitting(async () => {
		return withQueuedSync(
			match.eventId,
			async () => {
				const { matches, totals, gameContext } = await MatchService.deleteMatch(
					match.id
				);
				updateGameContext(gameContext, dispatch);

				Alert.success("Match was deleted successfully");
				dispatch({
					type: DELETE_MATCH_COMPLETE,
					payload: { matches, totals }
				});
			},
			dispatch
		);
	}, dispatch);
